module.exports = __webpack_public_path__ + "static/media/icon-cancel-small.82db2cd7.svg";